import {TaskAttachment} from "./TaskAttachment";
import {TaskSupplier} from "./TaskSupplier";
import {WorkorderFeedback} from "./WorkorderFeedback";

export class Task {
  constructor(
    public readonly id: string,
    public readonly projectId: string|null,
    public readonly teamId: string|null,
    public readonly startAt: Date|null,
    public readonly durationMinutes: number|null,
    public readonly description: string,
    public readonly color: string|null,
    public readonly suppliers: TaskSupplier[],
    public readonly relatedSuppliers: TaskSupplier[],
    public readonly suppliersStatus: string,
    public readonly taskTemplateId: string|null,
    public readonly quantityType: string|null,
    public readonly quantityAmount: number|null,
    public readonly quantityThickness: number|null,
    public readonly thicknessUnit: string|null,
    public readonly status: TaskStatus,
    /** @deprecated use Status instead */
    public readonly isInvoiced: boolean,
    /** @deprecated use Status instead */
    public readonly isVoided: boolean,
    public readonly isLocked: boolean,
    public readonly isSent: boolean,
    public readonly shouldGenerateWorkorder: boolean,
    public readonly workorderRemark: string|null,
    public readonly workorderStatus: 'complete'|'incomplete'|'unknown',
    public readonly isWorkorderRemarkImportant: boolean,
    public readonly projectRemark: string|null,
    public readonly isProjectRemarkImportant: boolean,
    public readonly todos: {[text: string]: boolean},
    public readonly taskAttachments: TaskAttachment[],
    public readonly workorderFeedback: WorkorderFeedback[]|null
  ) {}

  static fromJson(json: any): Task {
    return new Task(
      String(json['id']),
      (json['project_id'] !== null && json['project_id'] !== '0') ? String(json['project_id']) : null,
      json['team_id'],
      json['start_at'] ? new Date(json['start_at']) : null,
      json['duration'] ? Number(json['duration']) : null,
      json['description'],
      json['color'],
      (json['suppliers'] ?? []).map((supplier: any) => TaskSupplier.fromJson(supplier)),
      (json['related_suppliers'] ?? []).map((supplier: any) => TaskSupplier.fromJson(supplier)),
      json['suppliers_status'],
      json['task_template_id'] ?? null,
      json['quantity_type'],
      json['quantity_amount'],
      json['quantity_thickness'],
      json['thickness_unit'],
      json['status'],
      json['is_invoiced'] ?? false,
      json['is_voided'] ?? false,
      json['is_locked'] ?? false,
      json['sent'] ?? false,
      json['should_generate_workorder'] ?? null,
      json['workorder_remark'] ?? null,
      json['workorder_status'] ?? 'unknown',
      json['is_workorder_remark_important'] ?? false,
      json['project_remark'] ?? null,
      json['is_project_remark_important'] ?? false,
      json['todos'] ?? {},
      (json['task_attachments'] ?? []).map((attachment: any) => TaskAttachment.fromJson(attachment)),
      (json['workorder_feedback'] ?? []).map((attachment: any) => WorkorderFeedback.fromJson(attachment)),
    );
  }
}

export enum TaskStatus {
  // Standaard status van een taak
  open = 'open',
  // Wanneer een taak vervallen is, wordt niet meer gefactureerd
  voided = 'voided',
  // Wanneer een taak gefactureerd is
  invoiced = 'invoiced',
  // In het geval de taak onder garantie valt
  service = 'service'
}